import {api} from './api';

export const getSections = (plataforma: string | null) => {
    return api.get('section/', {params:{plataforma}}).then(res => {
        return res.data.filter((r:any) => r.enabled)
    })
}